import { useSelector } from 'react-redux'
import { selectCounter } from '../../stores/ticketsScanner/actions'

const TicketsScannerCheckedInLabel = () => {
  const counter = useSelector(selectCounter)

  return (
    <span className="label checked-in">
      {I18n.t("tickets_scanner.checked_in")}: {counter.checked}/{counter.total}
    </span>
  )
}

export default TicketsScannerCheckedInLabel
